import { Link } from "react-router-dom";
import ImageGallery from "@/components/ImageGallery";
import { Trophy } from "lucide-react";

const CharacterCard = ({ character }) => {
  const hasMultipleImages = character.images?.length > 0;

  return (
    <Link 
      to={`/character/${character.id}`}
      className="group block card-surface overflow-hidden"
      data-testid={`character-card-${character.id}`}
    >
      {/* Image */}
      <div className="relative aspect-[3/4] overflow-hidden">
        {hasMultipleImages ? (
          <div onClick={(e) => e.preventDefault()} className="w-full h-full relative">
            <ImageGallery
              images={character.images}
              mainImage={character.image}
              alt={character.name}
            />
          </div>
        ) : (
          <img 
            src={character.image || "https://static.prod-images.emergentagent.com/jobs/f60715c2-3b6b-4c99-a6c8-5c96b98e6cf9/images/c87d923edbc4557b647ae3b5b7af92b6c1f0325cd0bb5d5d8bdfa7f98e780e7d.png"}
            alt={character.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-transparent to-transparent pointer-events-none" />
        {character.popularity_rank && (
          <div className="absolute top-2 right-2 flex items-center gap-1 text-[10px] font-mono font-bold tracking-wider text-amber-400 bg-black/70 backdrop-blur-sm px-2 py-1 rounded-full border border-amber-500/30 pointer-events-none" data-testid="card-rank-badge">
            <Trophy className="w-3 h-3" /> #{character.popularity_rank}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-lg font-bold text-white mb-1 group-hover:text-yellow-500 transition-colors font-['Outfit']">
          {character.name}
        </h3>
        {character.species && (
          <p className="text-amber-500 text-xs font-mono uppercase tracking-wider mb-1">
            {character.species}
          </p>
        )}
        {character.actors?.length > 0 && (
          <p className="text-slate-500 text-xs mb-1.5 truncate" data-testid="card-actors">
            {character.actors.join(", ")}
          </p>
        )}
        <p className="text-slate-400 text-sm line-clamp-2">
          {character.description}
        </p>
      </div>
    </Link>
  );
};

export default CharacterCard;
